import { Icon } from "@rentiohq/web-shared/dist/components";

export const renderTooltipChecklist = (
  checklist: { label: JSX.Element | string; success: boolean }[],
) => checklist.map(item => <div>{item.label}</div>);

export const renderPOTooltipChecklist = (
  checklist: { label: JSX.Element | string; success: boolean }[],
) =>
  checklist.map(({ label, success }) => (
    <p
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      {success ? (
        <Icon source="checked" size="medium" />
      ) : (
        <Icon source="cross" size="medium" />
      )}{" "}
      {label}
    </p>
  ));
